import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost, handleDateChangeEvent } from '../../../../utils/AxiosUtil';
import * as enums from '../../../../utils/EnumMapping';
import { toDateFormat, trimSpaces } from '../../../../utils/Util';
import ErrorAwareAmountField from '../../../common/inputfields/ErrorAwareAmountField';
import ErrorAwareDatePicker from '../../../common/inputfields/ErrorAwareDatePicker';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';
import MyAutocomplete from '../../../common/inputfields/MyAutocomplete';
import NewAgainField from '../../../common/inputfields/NewAgainField';
import PaymentMethodFormControl from '../../../common/inputfields/PaymentMethodFormControl';
import * as util from './IncomingBillUtil';
import { Checkbox, FormControlLabel } from '@material-ui/core';

class NewIncomingBill extends Component {
    fields = util.fields;
    state = {
        newAgain: false,
        isInsurance: false,

        selectedCurrency: enums.currencies[0],
        selectedPaymentMethod: enums.paymentMethods[0],
        selectedType: enums.billTypes[0],
        selectedCustomer: {},
        selectedCategory: {},
        selectedLinkBill: {},

        billDate: new Date(),
        fulfillmentDate: new Date(),
        paymentDeadline: new Date(),

        vat: null,
        amount: null,

        billNumber: '',
        comment: '',

        selectedInsuranceType: enums.insuranceTypes[0],
        selectedCar: null,
        insuranceStartDate: new Date(),
        insuranceEndDate: new Date(),
        insuranceDescription: '',

        hideLinkBillComponent: true,
        customerRelatedDropDown: true,
        disableBillTypeComponent: true,
        errors: new Map(),
    }

    resetForm = () => {
        this.setState({
            newAgain: false,
            isInsurance: false,

            selectedCurrency: enums.currencies[0],
            selectedPaymentMethod: enums.paymentMethods[0],
            selectedType: enums.billTypes[0],
            selectedCustomer: {},
            selectedCategory: {},
            selectedLinkBill: {},

            billDate: new Date(),
            fulfillmentDate: new Date(),
            paymentDeadline: new Date(),

            vat: null,
            amount: null,

            billNumber: '',
            comment: '',

            selectedInsuranceType: enums.insuranceTypes[0],
            selectedCar: null,
            insuranceStartDate: new Date(),
            insuranceEndDate: new Date(),
            insuranceDescription: '',

            hideLinkBillComponent: true,
            customerRelatedDropDown: true,
            disableBillTypeComponent: true,
            errors: new Map(),
        })
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const insuranceRequest = this.state.isInsurance ? {
            "carId": this.state.selectedCar.value,
            "insuranceType": this.state.selectedInsuranceType.value,
            "startDate": toDateFormat(this.state.insuranceStartDate),
            "endDate": toDateFormat(this.state.insuranceEndDate),
            "description": this.state.insuranceDescription,
        } : null;

        const path = '/api/incomingbill';
        const requestObject = {
            "publicId": this.state.selectedLinkBill ? this.state.selectedLinkBill.value : null,
            "currency": this.state.selectedCurrency.value,
            "paymentMethod": this.state.selectedPaymentMethod.value,
            "customerId": this.state.selectedCustomer.value,
            "categoryId": this.state.selectedCategory.value,
            "type": this.state.selectedType.value,

            "billDate": toDateFormat(this.state.billDate),
            "fulfillmentDate": toDateFormat(this.state.fulfillmentDate),
            "paymentDeadline": toDateFormat(this.state.paymentDeadline),

            "vat": trimSpaces(this.state.vat),
            "amount": trimSpaces(this.state.amount),

            "billNumber": this.state.billNumber,
            "comment": this.state.comment,

            "categoryType": this.state.isInsurance ? "CAR_INSURANCE" : null,
            "incomingBillInsuranceRequest": insuranceRequest,

        };
        console.log(requestObject);
        handlePost(path, requestObject, this);
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <PaymentMethodFormControl
                            options={enums.paymentMethods}
                            value={this.state.selectedPaymentMethod}
                            onChange={(event) => util.handlePaymentMethodChange(event, this)} />
                    </div>
                    <div className='input-group'>
                        <MyAutocomplete
                            value={this.state.selectedCustomer}
                            getOptions={util.promiseCustomerOptions}
                            onChange={(e, v) => util.handleCustomerSelected(e, v, this)}
                            label={'Megnevezés'}
                            createLabel={'Új beszállító'}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            required
                            id="bill-date"
                            name="billDate"
                            label="Számla kelte"
                            errors={this.state.errors}
                            value={this.state.billDate}
                            onChange={(value) => util.handleBillDateChange(value, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            required
                            id="fullfillment-date"
                            name="fullFillmentDate"
                            label="Teljesítés kelte"
                            errors={this.state.errors}
                            value={this.state.fulfillmentDate}
                            onChange={(value) => util.handleFulfillmentDateChange(value, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            required
                            name="billNumber"
                            id="bill-number"
                            label="Sorszám"
                            autoComplete="on"
                            errors={this.state.errors}
                            value={this.state.billNumber}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            required
                            id="payment-deadline-date"
                            name="paymentDeadline"
                            label="Fizetési határidő"
                            errors={this.state.errors}
                            value={this.state.paymentDeadline}
                            onChange={(value) => util.handlePaymentDeadlineChange(value, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            required
                            id="amount"
                            name="amount"
                            label="Bruttó összeg"
                            value={this.state.amount}
                            errors={this.state.errors}
                            onChange={e => util.handleAmountChange(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            required
                            id="vat"
                            name="vat"
                            label="Áfa összege"
                            value={this.state.vat}
                            errors={this.state.errors}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Megjegyzés"
                            errors={this.state.errors}
                            value={this.state.comment}
                            onChange={e => handleChangeEvent(e, this)}
                            inputProps={{ maxLength: 5000 }}
                        />
                        <div style={{ textAlign: 'right', fontSize: '0.75rem', color: '#666', marginTop: '2px' }}>
                            {(this.state.comment || '').length} / 5000
                        </div>
                    </div>
                    <div className='input-group'>
                        <MyAutocomplete
                            value={this.state.selectedCategory}
                            getOptions={util.promiseCategoryOptions}
                            onChange={(e, v) => util.handleCategorySelected(e, v, this)}
                            label={'Költségviselő'}
                            createLabel={'Új költségviselő'} />
                    </div>
                    <div className='input-group'>
                        <FormControl variant="outlined" fullWidth required>
                            <InputLabel id="type-label">Számla típusa</InputLabel>
                            <Select
                                labelId="type-label"
                                id="type"
                                value={this.state.selectedType}
                                onChange={(event) => util.handleBillTypeChange(event, this)}
                                label="Számla típusa"
                                disabled={this.state.disableBillTypeComponent}>
                                {enums.billTypes.map((value, index) =>
                                    <MenuItem key={index} value={value}>{value.label}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </div>
                    <div className='input-group'>
                        <MyAutocomplete
                            value={this.state.selectedLinkBill}
                            getOptions={() => util.promiseLinkBillOptions(this)}
                            onChange={(e, v) => util.handleLinkBillSelected(e, v, this)}
                            hidden={this.state.hideLinkBillComponent}
                            disabled={this.state.customerRelatedDropDown}
                            label={'Linkelt számla'}
                            renderOption={(option, { selected }) => (
                                <div className="ittttttt">
                                    {console.log(option)}
                                    {option.label}
                                </div>
                            )}
                        />
                    </div>
                    {this.state.isInsurance &&
                        <>
                            <div className="divider-container">
                                <hr className="insurance-divider" />
                                <span className="divider-title">Biztosítási adatok</span>
                            </div>
                            <div className='input-group'>
                                <MyAutocomplete
                                    value={this.state.selectedCar}
                                    defaultvale={this.state.selectedCar}
                                    getOptions={util.promiseCarOptions}
                                    onChange={(e, v) => util.handleCarSelected(e, v, this)}
                                    label={'Autó'}
                                />
                            </div>
                            <div className='input-group'>
                                <FormControl variant="outlined" fullWidth required>
                                    <InputLabel id="insurance-type-label">Biztosítás típusa</InputLabel>
                                    <Select
                                        name="selectedType"
                                        labelId="insurance-type-label"
                                        id={this.props.name}
                                        value={this.state.selectedInsuranceType}
                                        onChange={e => handleChangeEvent(e, this)}
                                        label="Biztosítás típusa">
                                        {enums.insuranceTypes.map((value, index) =>
                                            <MenuItem key={index} value={value}>{value.label}</MenuItem>
                                        )}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className='input-group'>
                                <ErrorAwareDatePicker
                                    required
                                    id="insuranceStartDate"
                                    name="insuranceStartDate"
                                    label="Kezdő dátum"
                                    errors={this.state.errors}
                                    value={this.state.insuranceStartDate}
                                    onChange={v => handleDateChangeEvent(v, "insuranceStartDate", this)}
                                />
                            </div>
                            <div className='input-group'>
                                <ErrorAwareDatePicker
                                    required
                                    id="insuranceEndDate"
                                    name="insuranceEndDate"
                                    label="Vége dátum"
                                    errors={this.state.errors}
                                    value={this.state.insuranceEndDate}
                                    onChange={v => handleDateChangeEvent(v, "insuranceEndDate", this)}
                                />
                            </div>
                            <div className='input-group'>
                                <ErrorAwareTextField
                                    name="insuranceDescription"
                                    label="Leírás"
                                    value={this.state.insuranceDescription}
                                    onChange={e => handleChangeEvent(e, this)}
                                />
                            </div>
                        </>}
                    {/*<div className='input-group'>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel id="currency-label">Pénznem</InputLabel>
                                <Select
                                    labelId="currency-label"
                                    id="currency"
                                    value={this.state.selectedCurrency}
                                    onChange={(event) => this.setState({ selectedCurrency: event.target.value })}
                                    label="Pénznem"
                                    disabled={true}>
                                    {enums.currencies.map((value, index) =>
                                        <MenuItem key={index} value={value}>{value.label}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                                    </div>*/}
                </div>
                <div className="form-actions">
                    <FormControlLabel
                        value="isInsurance"
                        control={<Checkbox color="primary" checked={this.state.isInsurance} onChange={e => this.setState({ isInsurance: e.target.checked })} />}
                        label="Biztosítás?"
                        labelPlacement="start"
                        className="another-checkbox"
                    />
                    <NewAgainField
                        checked={this.state.newAgain}
                        onChange={e => this.setState({ newAgain: e.target.checked })} />
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(NewIncomingBill);
